import React from 'react';

const TestSite = () => {
    return (
        <div className="p-2 bg-danger text-center text-white">This is a test site. Please enter test data. Thank you</div>
    );
}

export default TestSite;
